import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getCampaignEndDate } from '@src/redux/modules/campaignLandingPage';
import VpSplash from '@src/containers/CampaignLandingPage/VpSplash';

const CampaignExpiredPage = ({ endDate }) => {
  const formattedDate = endDate
    ? new Date(endDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <Box>
      <VpSplash />
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2}
        sx={{ mt: 8, px: 3, textAlign: 'center' }}
      >
        <Typography variant="h5" fontWeight={600} color="text.primary">
          This campaign has ended
        </Typography>
        {formattedDate && (
          <Typography variant="body1" color="text.secondary">
            This campaign closed on {formattedDate}.
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          Thank you for your interest. No new submissions are being accepted at this time.
        </Typography>
      </Stack>
    </Box>
  );
};

CampaignExpiredPage.propTypes = {
  endDate: PropTypes.string,
};

const mapStateToProps = (state) => ({
  endDate: getCampaignEndDate(state),
});

export default connect(mapStateToProps)(CampaignExpiredPage);



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignExpiredPage/CampaignExpiredPage.jsx